export default __webpack_public_path__ + "static/media/f.687a8d20.svg";